module.exports = __webpack_public_path__ + "static/media/i.1dfe9d77.gif";